import React from 'react'
import { NextPage } from 'next'
import { ContentfulProvider } from '@pcln/contentful-components'
import Layout from '@/components/Layout'
import { CustomContext, PageProps } from '@/types'
import VIP from '@/components/VIP'
import generateBootstrapData from '../utils/generate-bootstrap-data'
import fetchPCLNHeaderFooterContent from '../server/utils/pcln-header-footer'
import fetchSignInStatus from '../server/utils/signin-status'
import getCookies from '../server/utils/get-cookies'
import getPclnHeaders from '../server/utils/get-pcln-headers'

const Vip: NextPage<PageProps> = ({
  headerHTML,
  footerHTML,
  bootstrapData
}) => {
  return (
    <ContentfulProvider contentful={bootstrapData.contentful}>
      <Layout headerHTML={headerHTML} footerHTML={footerHTML}>
        <VIP />
      </Layout>
    </ContentfulProvider>
  )
}

export async function getServerSideProps(ctx: CustomContext) {
  const { req, res } = ctx
  const pricelineSpecificHeaders = getPclnHeaders(req)

  const bootstrapData = generateBootstrapData(req, res)
  const { webstats } = bootstrapData
  const { clientGUID: cguid } = webstats

  const [pclnHeaderFooterContent, signInStatus] = await Promise.all([
    fetchPCLNHeaderFooterContent(req, res),
    fetchSignInStatus(
      cguid,
      getCookies(req).dmc || '',
      pricelineSpecificHeaders
    )
  ])

  if (res) {
    if (signInStatus.signedIn) {
      res.writeHead(302, { Location: `/next-profile${req.originalUrl}` })
      res.end()
    }
  }

  return {
    props: {
      ...pclnHeaderFooterContent,
      bootstrapData: {
        ...bootstrapData,
        signInStatus
      }
    }
  }
}

export default Vip
